import { gql } from '@apollo/client';

import { BrandDetailsFragment } from '../fragments-hg';

export const BrandDetailsQuery = gql`
  query BrandDetails($id: ID!, $owner: BrandOwnerInput) {
    brand(id: $id, owner: $owner) {
      ...brandDetails
    }
  }
  ${BrandDetailsFragment}
`;

export const BrandingAssetsQuery = gql`
  query BrandingAssets($input: GetBrandingAssetsInput!) {
    brandingAssets(input: $input) {
      id
      url
      isDeletable
      isLiveOnAd
      isOnDefaultBrand
      numberOfLiveAds
      numberOfBrands
      strategies {
        ... on LogoStrategies {
          serpLogo
          jdpLogo
        }
        ... on CoverStrategies {
          jdpCoverThumbnail
          jdpCover
        }
      }
    }
  }
`;

export const ListBrandsQuery = gql`
  query ListBrands($owner: BrandOwnerInput!) {
    brands(owner: $owner) {
      ...brandDetails
    }
  }
  ${BrandDetailsFragment}
`;

export const ListBrandsIdQuery = gql`
  query ListBrands($owner: BrandOwnerInput!) {
    brands(owner: $owner) {
      id
      state
    }
  }
`;

export const getBrandQuery = gql`
  query getBrand($brandId: ID!, $owner: BrandOwnerInput) {
    brand(id: $brandId, owner: $owner) {
      assets {
        cover {
          strategies
          url
        }
        logo {
          strategies
          url
        }
      }
    }
  }
`;

export const getHeaderFooterContext = gql`
  query getHeaderFooterContext {
    headerFooterContext {
      identityContext {
        email
        act {
          operatorEmail
          csToggleHref
          isCsView
        }
      }
      user {
        name
        firstName
        id
      }
      advertiser {
        name
        billingId
        permissionOptions {
          canCreateJobs
          canManageBrand
          canManageCompanyProfile
          canManageUsers
          canPayInvoices
          canViewInvoiceHistory
          canViewManagerReports
        }
        showOnCreditHoldMessage
        isActivationPending
        switchAccountsHref
        hasMultipleAccounts
        isAgency
        canManageCompanyProfile
      }
    }
  }
`;
